const editPrivilegeSchema ={
    feilds: [{
        id: 1,
        name: 'privilege_name',
        title: 'Privilege Name*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Privilege Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 2,
        name: 'emergency',
        title: 'Emergency*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Emergency'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 3,
        name: 'form_type',
        title: 'Form Type*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value !== 0 && value !==undefined);
                },
                message: 'Please Select Form Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }
    ,{
        id: 5,
        name: 'unitname',
        title: 'Unit Name*',
        visible: true,
        element: 'text',
        required: true,
        input_type: 'text',
        // placeholder: 'Select',
        icon: 'user',
        // rules: [
        //     {
        //         test: (value) => {
        //             return (value !== null && value.length > 0);
        //         },
        //         message: 'Please Select Form Type'
        //     }
        // ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    },{
        id: 6,
        name: 'status',
        title: 'Status*',
        visible: true,
        element: 'status',
        required: true,
        input_type: 'text',
        // placeholder: 'Select',
        icon: 'user',
        // rules: [
        //     {
        //         test: (value) => {
        //             return (value !== null && value.length > 0);
        //         },
        //         message: 'Please Select Form Type'
        //     }
        // ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    },
    {
        id: 7,
        name: 'admission',
        title: 'Admission*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Emergency'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 8,
        name: 'whatsapp',
        title: 'Send Whatsapp*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Send Whatsapp'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }
    ]
}

export {editPrivilegeSchema};